module.exports = __webpack_public_path__ + "static/bbis-air-conditioning-min-8ef08211533192f832e2afb375278b7c.jpg";